/*
 * 苏州海管家物流科技有限公司（https://www.hgj.com/）.
 * 苏公网安备32059002003385号 © 2015-2023 Hgj.com All Rights Reserved. | 苏ICP备15030950号.
 * @Date: 2023.09.05.
 * @Author
 * @Description 恪保 - 入口文件 vue注册、组件挂载.
 **/
import 'core-js/actual/array/at' // 兼容pdfjs-dist需要的 at 方法

// FinalizationRegistry polyfill 兼容老版本浏览器 (Safari < 14.1, Android WebView < 84) pdfjs-dist
if (typeof globalThis.FinalizationRegistry === 'undefined') {
  ;(globalThis as any).FinalizationRegistry = class FinalizationRegistry {
    register() {}
    unregister() {}
  }
}
import { createApp } from 'vue'
import { useAuthStore } from '@/store/authStore'
import { createPinia } from 'pinia'
import piniaPluginPersistedstate from 'pinia-plugin-persistedstate'
import { initVue3Tracker } from '@hgj/storybrooke-business-tracker'
import { i18n, loadI18nLanguage } from './i18n/index'

import HElementPlus from '@hgj/element-plus'
import '@hgj/element-plus/dist/index.css'

import router from './router/index'

import '@/assets/icon/iconfont.css'
import '@/assets/icon-base/iconfont.css'
import '@/assets/icon/iconfont.js'
import '@/assets/icon-base/iconfont.js'

import '@/assets/css/base.css'
import '@/assets/css/reset.scss'
import '@/assets/css/common.scss'
import '@/assets/css/element.scss'

import 'default-passive-events' // google 滚动
import '@stroybrooke-business-tools/components/es/style.css'

import 'virtual:uno.css'

import AOS from 'aos'
import 'aos/dist/aos.css'
import VueDOMPurifyHTML from 'vue-dompurify-html'
import App from './App.vue'
import directives from './directives'
import { isGlobal } from './utils/constant'
import { initBackstageOnlineEditContextFromUrl } from '@/utils/backstageOnlineEdit'

// 动画
AOS.init({
  // 全局设置：
  disable: false, // 接受以下值：'phone','tablet','mobile',布尔值，表达式或函数,禁用不同设备下的aos
  startEvent: 'DOMContentLoaded', // 在文档上分派的事件的名称，AOS应该在该事件上进行初始化
  initClassName: 'aos-init', // 初始化后应用的类
  animatedClassName: 'aos-animate', // 应用于动画的类
  useClassNames: true, // 如果为真，将在滚动中添加data-aos的内容作为类
  disableMutationObserver: false, // 取消自动突变检测(高级)
  debounceDelay: 10, // 在调整窗口大小时使用的取消延迟(高级)
  throttleDelay: 10, // 滚动页面时使用的油门延迟（高级）

  // 可以通过data-aos属性逐个设置的设置：
  offset: 100, // 初始触发点的偏移量(单位:px)
  delay: 0, // 延迟时间值从0到3000 ，步长为50毫秒，
  duration: 800, // 持续时间,值从0到3000，步长为50毫秒
  easing: 'ease', // AOS动画的默认缓动
  once: false, // 动画是否应该只发生一次
  mirror: true, // 当滚动经过元素时，是否应该将其动画化
  anchorPlacement: 'top-bottom', // 定义元素相对于窗口的哪个位置应该触发动画
})

const app = createApp(App as any)
const environment = import.meta.env.VITE_APP_PREFIX.slice(0, -1)
const trackerParams: any = {
  environment: environment as 'dev' | 'beta' | 'prod',
  productCode: 'saas-insurance',
  router,
}
isGlobal &&
  (trackerParams.baseUrl =
    import.meta.env.VITE_BASE_URL + '/storybrooke-logger')
const { install } = initVue3Tracker(trackerParams)

async function serviceStart() {
  const pinia = createPinia()
  pinia.use(piniaPluginPersistedstate)
  app.use(HElementPlus).use(pinia)
  loadI18nLanguage()
  app.use(i18n)
  // .use(i18n) // { i18n: i18n.global.t }
  app.use(router)
  app.use({ install })
  app.use(directives)
  app.use(VueDOMPurifyHTML)
  // 上述插件注册后在挂载#app之前执行用户信息的获取保证项目中随时可以获取用户信息
  try {
    const useStore = useAuthStore()
    initBackstageOnlineEditContextFromUrl()
    await useStore.setToken() // 设置 中台  token
    await useStore.setUInfoAtStartApp() // 设置 用户 信息
    useStore.setUserWalletInfo() // 设置 用户 海币和券数量
    useStore.initInsuranceCompanyInfo()
  } catch (error) {
    console.log('serviceStart->', error)
  }
  app.mount('#app')
}
serviceStart()
